<template>
  <section class="settings-page">

    <!-- HEADER -->
    <header class="settings-header">
      <h1>Profile</h1>
      <p>Manage your profile, security, and privacy preferences.</p>
    </header>

    <!-- MAIN GRID -->
    <section class="settings-grid">

      <!-- LEFT COLUMN -->
      <div class="space-y" style="margin-top: 2rem;">
        <div class="card">

          <!-- BASIC INFORMATION -->
          <h3>Basic Information</h3>

          <div class="two-col">
            <div class="field">
              <label>Gender</label>
              <select v-model="gender">
                <option value="">Select</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="non_binary">Non-binary</option>
              </select>
            </div>

            <div class="field">
              <label>Age Range</label>
              <select v-model="age_range">
                <option value="">Select</option>
                <option value="13-17">13–17</option>
                <option value="18-24">18–24</option>
                <option value="25-34">25–34</option>
                <option value="35-44">35–44</option>
                <option value="45_plus">45+</option>
              </select>
            </div>
          </div>

          <div class="two-col">
            <div class="field">
              <label>Occupation</label>
              <select v-model="occupation">
                <option value="">Select</option>
                <option>Student</option>
                <option>Working Professional</option>
                <option>Business Owner</option>
                <option>Freelancer</option>
                <option>Homemaker</option>
                <option>Other</option>
              </select>
            </div>

            <div class="field">
              <label>City Tier</label>
              <select v-model="city_tier">
                <option value="">Select</option>
                <option value="tier_1">Tier 1 (Metro)</option>
                <option value="tier_2">Tier 2 (Urban)</option>
                <option value="tier_3">Tier 3 (Semi-Urban)</option>
                <option value="rural">Rural</option>
              </select>
            </div>
          </div>

          <div class="two-col">
            <div class="field">
              <label>Annual Personal Income</label>
              <select v-model="fan_profile_income">
                <option value="">Select</option>
                <option v-for="i in incomeOptions" :key="i" :value="i">{{i}}</option>
              </select>
            </div>

            <div class="field">
              <label>Primary Social Platform</label>
              <select v-model="platform">
                <option value="">Select</option>
                <option value="Instagram">Instagram</option>
                <option value="Youtube">YouTube</option>
                <option value="Tiktok">TikTok</option>
                <option value="X">X</option>
                <option value="Other">Other</option>
              </select>
            </div>
          </div>

          <div class="field">
            <label>Country (Optional)</label>
            <select v-model="country">
              <option value="">Select</option>
              <option value="India">India</option>
              <option value="USA">USA</option>
              <option value="UK">UK</option>
              <option value="Other">Other</option>
            </select>
          </div>
        </div>





      </div>
      <div class="space-y" style="margin-top: 2rem;">
        <div class="card">

          <h3>Buying Behaviour</h3>

          <div class="field">
            <label>Purchased influencer product?</label>

            <div class="radio-row">
              <label class="radio-card">
                <input type="radio" value="Yes" v-model="purchased">
                <span>Yes</span>
              </label>

              <label class="radio-card">
                <input type="radio" value="No" v-model="purchased">
                <span>No</span>
              </label>
            </div>
          </div>

          <div class="field">
            <label>Monthly Online Spending</label>

            <div class="radio-row">
              <label class="radio-card" v-for="opt in [
                {label:'₹0 – ₹1,000', val:'0-1000'},
                {label:'₹1,000 – ₹3,000', val:'1000-3000'},
                {label:'₹3,000 – ₹7,000', val:'3000-7000'},
                {label:'₹7,000 – ₹15,000', val:'7000-15000'},
                {label:'₹15,000 – ₹50,000', val:'15000-50000'},
                {label:'₹50,000 +', val:'50000+'}
              ]" :key="opt.val">

                <input type="radio" :value="opt.val" v-model="spending">
                <span>{{opt.label}}</span>

              </label>
            </div>
          </div>

          <div class="field">
            <label>Spending Categories</label>

            <div class="multi-custom">
              <div v-for="opt in categoryOptions" :key="opt" class="multi-item"
                :class="{ active: categories.includes(opt) }" @click="toggleCategory(opt)">
                {{ opt }}
              </div>
            </div>

          </div>


        </div>
        <div class="settings-footer">

          <div class="footer-card">

            <div class="footer-text">
              <h4>Update Changes</h4>
              <p>Your profile updates will improve creator insights.</p>
            </div>

            <button class="footer-save-btn" @click="saveAllSettings">
              {{ isLoading ? "Saving..." : "Update" }}
            </button>

          </div>

        </div>
      </div>


    </section>


  </section>
</template>

<script>
  import { getFanSettings1, saveFanSettingsApi } from "../apis/fanapis";
  import { useToast } from "vue-toastification";

  export default {
    name: "FanContent",
    toast: null,
    data() {
      return {
        categoryOptions: [
          "Fashion", "Beauty", "Fitness", "Tech", "Gaming",
          "Finance", "Travel", "Food", "Luxury", "Education", "Crypto", "Other"
        ],
        showProfileModal: false,
        showPasswordModal: false,

        editProfile: {
          user_name: "",
          user_mobile: ""
        },

        password: {
          current: "",
          new: "",
          confirm: ""
        },
        user_id: "",
        userDt: null,
        isLoading: false,
        gender: "",
        age_range: "",
        occupation: "",
        city_tier: "",
        platform: "",
        country: "",

        // Segment 2
        purchased: "",
        spending: "",
        categories: [],
        incomeOptions: [
          "No Income",
          "₹0 – ₹2,50,000",
          "₹2,50,000 – ₹5,00,000",
          "₹5,00,000 – ₹10,00,000",
          "₹10,00,000 – ₹20,00,000",
          "₹20,00,000+"
        ],

        // Segment 3
        discount_code: "",
        purchase_frequency: "",
        price_sensitivity: "",
        fan_profile_income: "",
        clicked_link: "",
        education: ""
      };
    },

    mounted() {
      this.toast = useToast();
      const ldataRaw = sessionStorage.getItem("ldata");
      const ldata = ldataRaw ? JSON.parse(ldataRaw) : null;

      if (ldata) {
        this.userDt = ldata;
        this.user_id = ldata.user_id;
        this.loadSettings();
      }
    },

    methods: {
      toggleCategory(opt) {
        if (this.categories.includes(opt)) {
          this.categories = this.categories.filter(c => c !== opt);
        } else {
          // if (this.categories.length >= 3) {
          //   this.toast.error("Max 3 categories allowed");
          //   return;
          // }
          this.categories.push(opt);
        }
      },
      async saveAllSettings() {

        this.isLoading = true;

        const res = await saveFanSettingsApi({

          user_id: this.user_id,

          gender: this.gender,
          age_range: this.age_range,
          occupation: this.occupation,
          city_tier: this.city_tier,
          platform: this.platform,
          income: this.fan_profile_income,
          country: this.country,

          purchased: this.purchased,
          spending: this.spending,
          categories: JSON.stringify(this.categories),

          discount_code: this.discount_code,
          purchase_frequency: this.purchase_frequency,
          price_sensitivity: this.price_sensitivity,
          clicked_link: this.clicked_link,
          education: this.education
        });

        this.isLoading = false;

        if (res.status) {
          this.toast.success("Settings saved");
        } else {
          this.toast.error(res.success || "Failed");
        }

      },

      async loadSettings() {

        const res = await getFanSettings1({
          user_id: this.user_id
        });

        if (!res.status) {
          this.toast.error("Failed to load settings");
          return;
        }

        const p = res.profile || {};

        this.gender = p.gender || "";
        this.age_range = p.age_range || "";
        this.occupation = p.occupation || "";
        this.city_tier = p.city_tier || "";
        this.platform = p.platform || "";
        this.fan_profile_income = p.income || "";

        this.purchased = p.purchased || "";
        this.spending = p.spending || "";
        this.categories = p.categories || [];

        this.discount_code = p.discount_code || "";
        this.purchase_frequency = p.purchase_frequency || "";
        this.price_sensitivity = p.price_sensitivity || "";
        this.clicked_link = p.clicked_link || "";
        this.education = p.education || "";
      }

    }
  };
</script>

<style scoped>
  /* ===============================
BASE PAGE
=============================== */
  .settings-page {
    max-width: 1280px;
    margin: auto;
    padding: 40px 24px;
  }

  /* ===============================
HEADER
=============================== */
  .settings-header h1 {
    font-size: 32px;
    font-weight: 900;
    letter-spacing: -0.5px;
    color: #0f172a;
  }

  .settings-header p {
    color: #64748b;
    margin-top: 6px;
    font-size: 14px;
  }

  /* ===============================
GRID
=============================== */
  .settings-grid {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 28px;
    margin-top: 28px;
  }

  /* ===============================
CARD (GLASS STYLE)
=============================== */
  .card {
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(14px);
    border-radius: 20px;
    padding: 24px;
    border: 1px solid rgba(226, 232, 240, 0.8);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
    transition: all 0.2s ease;
  }

  .card:hover {
    transform: translateY(-2px);
  }

  .card h3 {
    font-size: 18px;
    font-weight: 800;
    margin-bottom: 18px;
  }

  /* ===============================
FIELD
=============================== */
  .field {
    margin-bottom: 14px;
  }

  .field label {
    font-size: 11px;
    text-transform: uppercase;
    color: #94a3b8;
    font-weight: 700;
    letter-spacing: .04em;
  }

  /* ===============================
INPUTS / SELECT
=============================== */
  .field select,
  .field input {
    width: 100%;
    margin-top: 6px;
    padding: 12px 14px;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    background: rgba(248, 250, 252, 0.7);
    font-weight: 600;
    transition: all .15s ease;
  }

  .field select:focus,
  .field input:focus {
    outline: none;
    border-color: #0f172a;
    background: white;
  }

  /* ===============================
TWO COL
=============================== */
  .two-col {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }

  /* ===============================
RADIO MODERN
=============================== */
  .radio-row {
    display: flex;
    gap: 10px;
    margin-top: 8px;
    flex-wrap: wrap;
  }

  .radio-card input {
    display: none;
  }

  .radio-card {
    padding: 10px 14px;
    border-radius: 12px;
    background: #f1f5f9;
    border: 1px solid transparent;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all .2s ease;
  }

  .radio-card:hover {
    background: #e2e8f0;
  }

  .radio-card:has(input:checked) {
    background: #0f172a;
    color: white;
  }

  /* ===============================
MULTI SELECT
=============================== */
  .multi {
    min-height: 100px;
    padding: 10px;
    border-radius: 12px;
  }

  /* ===============================
FOOTER SAVE CARD (UPGRADED)
=============================== */
  .settings-footer {
    margin-top: 30px;
  }

  .footer-card {
    background: linear-gradient(135deg, #0f172a, #1e293b);
    color: white;
    border-radius: 20px;
    padding: 22px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .footer-text h4 {
    font-size: 16px;
    font-weight: 800;
  }

  .footer-text p {
    font-size: 12px;
    opacity: 0.7;
  }

  .footer-save-btn {
    background: white;
    color: #0f172a;
    padding: 12px 20px;
    border-radius: 12px;
    font-weight: 700;
    transition: all .2s ease;
  }

  .footer-save-btn:hover {
    transform: scale(1.05);
  }

  /* ===============================
MOBILE
=============================== */
  @media (max-width: 900px) {
    .settings-grid {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 640px) {
    .settings-page {
      padding: 20px 14px;
    }

    .card {
      padding: 18px;
    }

    .two-col {
      grid-template-columns: 1fr;
    }

    .footer-card {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
    }

    .footer-save-btn {
      width: 100%;
      text-align: center;
    }
  }

  .multi-custom {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 8px;
  }

  .multi-item {
    padding: 10px 14px;
    border-radius: 12px;
    background: #f1f5f9;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid transparent;
  }

  .multi-item:hover {
    background: #e2e8f0;
  }

  .multi-item.active {
    background: #0f172a;
    color: white;
  }
</style>